import {NgModule} from '@angular/core';
import {SharedModule} from '../../shared/shared.module';
import {WorklistComponent} from './list/worklist.component';
import {WorklistRoutingModule} from './worklist.routing';
import {TranslateModule} from '@ngx-translate/core';
import {WorklistCreateComponent} from './worklist-create/worklist-create.component';
import {WorklistUpdateComponent} from './worklist-update/worklist-update.component';
import {
  WorkDetailComponent,
} from "./work-detail/work-status-detail.component";

@NgModule({
  declarations: [WorklistComponent, WorklistCreateComponent, WorklistUpdateComponent,WorkDetailComponent],
  imports: [SharedModule, WorklistRoutingModule, TranslateModule],
  exports: [
    WorklistUpdateComponent,
    WorklistCreateComponent,
    WorkDetailComponent
  ],
})
export class WorklistModule {
}
